import "./App.css";
import "./styles/site.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Medicare from "./pages/Medicare";
import Insurance from "./pages/Insurance";
import RetirementPlanning from "./pages/RetirementPlanning";
import About from "./pages/About";
import WhyChooseUs from "./pages/WhyChooseUs";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Appointment from "./pages/Appointment";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ChatWidget from "./components/ChatWidget";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const CHAT_PATHS = ["/privacy-policy", "/terms-of-service"];

const ChatScope = () => {
  const { pathname } = useLocation();
  return CHAT_PATHS.includes(pathname) ? <ChatWidget /> : null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ChatScope />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/medicare" element={<Medicare />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/retirement-planning" element={<RetirementPlanning />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
